var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 197,
    viewBox: "0 0 233 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_4846)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_376_4846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.505 216.189L97.713 229.358C87.9913 232.281 77.9111 227.025 75.061 217.547L39.1134 98.0015C36.2633 88.5233 41.7729 78.5796 51.4947 75.6563L174.111 38.7852C183.833 35.8619 193.913 41.1176 196.763 50.5959L210.449 96.1085C207.513 95.874 204.443 96.1453 201.553 97.0144C198.313 97.9889 195.453 99.5938 193.035 101.717L179.247 55.8631L56.63 92.7342L92.5777 212.28L137.333 198.822L136.652 200.051L141.505 216.189ZM84.4174 121.623L172.001 95.2863L166.865 78.2084L79.2821 104.545L84.4174 121.623ZM104.959 189.935L149.714 176.477L161.44 155.446L161.132 154.421L99.8236 172.857L104.959 189.935ZM94.6882 155.779L174.564 131.76L180.012 121.928L177.136 112.364L89.5528 138.701L94.6882 155.779ZM224.925 122.017L210.428 114.458C209.268 113.868 207.913 113.75 206.652 114.129C205.391 114.508 204.325 115.354 203.684 116.486L197.493 127.658L220.711 139.764L226.902 128.592C227.521 127.448 227.66 126.119 227.29 124.89C226.921 123.661 226.071 122.629 224.925 122.017ZM161.589 219.461L179.631 214.036L217.033 146.271L193.815 134.165L156.3 201.871L161.589 219.461Z",
    fill: "#0045B5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_4846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219.497,
    height: 214,
    fill: "white",
    transform: "translate(0 63.2075) rotate(-16.7362)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_376_4846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219.497,
    height: 214,
    fill: "white",
    transform: "translate(0 63.2075) rotate(-16.7362)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureFlagIcon);
export default __webpack_public_path__ + "static/media/feature-flag-icon.8be10042d17b2890865af3a8bc2ec09a.svg";
export { ForwardRef as ReactComponent };